import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { SecurityManagerService } from '@core/security-manager/security-manager.service';

/**
 * Make an element only display in the USA.
 * Usage:
 * <div *pmsUsaOnly class="not-a-real-class"></div>
 */
@Directive({
	selector: '[pmsUsaOnly]',
	standalone: false,
})
export class UsaOnlyDirective implements OnInit {

	constructor(
		private securityManagerService: SecurityManagerService,
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef,
	) {
	}

	ngOnInit() {
		this.updateView();
	}

	updateView() {
		if (!this.securityManagerService.isCanada()) {
			this.viewContainerRef.createEmbeddedView(this.templateRef);
		} else {
			this.viewContainerRef.clear();
		}
	}
}
